<template>
  <div>
    <table class="table table-sm table-hover table-striped">
      <thead>
      <tr>
        <td width="80px">Номер</td>
        <td width="200px">Клиент</td>
        <td width="300px">Адрес</td>
        <td>Препараты</td>
        <td width="80px">Сумма</td>
        <td width="170px">Курьер</td>
        <td width="100px">Дата доставки</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order in localOrders" :key="order.id">
        <td>
          {{ order.id }}
          <p><strong>{{ order.project_label }}</strong> ({{ $AllCities[order.city_id].short_name }})</p>
          <template v-if="showStoreData && order.is_agreed">
            <span class="badge badge-success">Согласовано</span>
          </template>
          <template
            v-if="(order.comment && order.comment.length) || order.reject_comment"
          >
            <i
              v-tooltip="{
                    content: getComments(order),
                    placement: 'bottom-center',
                    classes: ['info custom-tooltip'],
                    targetClasses: ['it-has-a-tooltip custom-tooltip'],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700
                    }
                  }"
              class="icon-fa icon-fa-info-circle comment_tooltip_fa"
            ></i>
          </template>
        </td>
        <td>
          <p>{{ order.client_name || (order.client && order.client.name) }}</p>
          <p v-for="phone in order.order_phones">{{ mixinPrintPhone(phone.phone.phone) }}</p>
          <AgreementButton
            v-if="!order.extra_options.callDeal"
            :order="order"
          />
        </td>
        <td>
          <p><strong>{{ $AllCities[order.city_id].name }}</strong></p>
          {{ order.address }}
        </td>
        <td :class="getOrderClass(order.id)">
          <div v-for="detail in order.details" class="drug_details">
            <p>
              {{ detail.drug.prep }} ({{ detail.drug_id }})
              <span v-if="detail.drug.cool" class="cool_mark"><i class="icon icon-snowflake"/></span>
              <i
                v-if="detail.drug.pack_comment"
                v-tooltip="{
                        content: detail.drug.pack_comment,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                class="icon-fa icon-fa-info-circle"
              ></i>
              <i
                v-if="detail.drug.pack_box_comment"
                v-tooltip="{
                        content: detail.drug.pack_box_comment,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                class="icon-fa icon-fa-info-circle"
              ></i>
            </p>
            <template v-if="detail.pack_set !== 1">
              <p><strong>x {{ detail.pack_set }}</strong> (компл)<strong> * {{
                  detail.price * detail.pack_set
                }}</strong></p>
              <p><strong>x {{ detail.qty }}</strong> завод. упак.<strong> * {{ detail.price }}</strong></p>
            </template>
            <template v-else>
              <p><strong>x {{ detail.qty }} * {{ detail.price }}</strong></p>
            </template>
            <template v-if="showStoreData">
              <StoreData :storeInfo="{
                actualStoreData: storeData.actualStoreData && storeData.actualStoreData[detail.drug_id],
                inStores: storeData.inStores[detail.drug_id],
                requests: storeData.requests[detail.drug_id],
                transitDetails: storeData.transitDetails[detail.drug_id],
              }"
                         :order="order"
                         :drug="detail.drug"
              />

              <!--              <p>Остаток на складе: <strong>{{ actualStore.inStore[detail.drug_id] || 0 }}</strong>-->
              <!--                <span v-if="actualStore.invoices[detail.drug_id] && actualStore.invoices[detail.drug_id].details_in">-->
              <!--                  (из них <strong>{{-->
              <!--                    actualStore.invoices[detail.drug_id].in ? actualStore.invoices[detail.drug_id].in : 0-->
              <!--                  }}</strong> в дороге {{ moment(actualStore.invoices[detail.drug_id].details_in[0].date) }})-->
              <!--                </span>-->
              <!--              </p>-->
              <!--              <p>БР склада общая: <strong>{{ actualRequests[detail.drug_id] || 0 }}</strong> <span v-if="storeRequest[detail.drug_id]">Запрос к МСК: <strong>{{ storeRequest[detail.drug_id] }}</strong></span>-->
              <!--              </p>-->
              <!--              <hr>-->
              <!--              <p>Без учета текущ. заявки свободные остатки</p>-->
              <!--              <p>Склад: <strong>{{ (actualStore.inStore[detail.drug_id] || 0) - (actualStore.invoices[detail.drug_id] && actualStore.invoices[detail.drug_id].in || 0) }}</strong>-->
              <!--                <span v-if="actualStore.invoices[detail.drug_id] && actualStore.invoices[detail.drug_id].details_in">-->
              <!--                  с учетом в дороге <strong>{{-->
              <!--                    actualStore.invoices[detail.drug_id].in ? actualStore.invoices[detail.drug_id].in : 0-->
              <!--                  }}</strong> ({{ moment(actualStore.invoices[detail.drug_id].details_in[0].date) }})-->
              <!--                </span>-->
              <!--                МСК: <strong>{{ storeData[detail.drug_id] || 0 }}</strong></p>-->
            </template>
          </div>
        </td>
        <td>
          <div class="flex">
            <div>{{ order.price }}</div>
            <div class="ml-2" v-if="sendMessageModal[order.id] && sendMessageModal[order.id].supervisor">
              <button @click="sendTelegramMessage(order.id, 'supervisorModal')" class="btn btn-default btn-sm"
                      type="button">
                <i class="icon-fa icon-fa-user-secret chat_icon"/>
              </button>
              <SendRunnerMessage
                v-if="sendMessageModal[order.id].supervisorModal"
                :data="order"
                type="supervisor"
                :onModalClose="() => sendMessageModal[order.id].supervisorModal = false"
              />
            </div>
          </div>
        </td>
        <td>
          <template v-if="order.courier">
            <p>{{ order.courier.name }}</p>
            <!--            <p>{{ order.courier.phone }}</p>-->
          </template>
          <div class="" v-if="sendMessageModal[order.id] && sendMessageModal[order.id].runner">
            <button @click="sendTelegramMessage(order.id, 'runnerModal')" class="btn btn-default btn-sm" type="button">
              <i class="icon-fa icon-fa-motorcycle chat_icon"/>
            </button>
            <SendRunnerMessage
              v-if="sendMessageModal[order.id].runnerModal"
              :data="order"
              type="runner"
              :onModalClose="() => sendMessageModal[order.id].runnerModal = false"
            />
          </div>
        </td>
        <td>
          {{ printCreateDate(order) }}
          <template v-if="showStoreData">
            <button
              @click="orderToEdit(order.id)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import SendRunnerMessage from '@/components/telegram/SendRunnerMessage'
import AgreementButton from '@/components/orders/Agreement/AgreementButton'
import StoreData from '@/components/drugs/StoreData'

export default {
  props: ['orders', 'storeStatus', 'showStoreData', 'storeData', 'storeRequest', 'actualRequests', 'actualStore'],
  components: {
    SendRunnerMessage,
    AgreementButton,
    StoreData,
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllDivisions() {
      return this.$store.getters['platform/divisions']
    },
    $StoresNotificationSettings() {
      return this.$store.getters['platform/storeNotificationSettings']
    },
  },
  watch: {
    orders: {
      handler: function (val, oldVal) {
        this.sortOrders()
      },
    }
  },
  mounted() {
    this.sortOrders()
  },
  data() {
    return {
      sendMessageModal: {},
      localOrders: [],
    }
  },
  methods: {
    sendTelegramMessage(orderId, type) {
      this.sendMessageModal[orderId][type] = true
    },
    sortOrders() {
      const sendMessageModal = {}
      // const citiesToStores = Object.values(this.$AllDivisions).reduce((acc, d) => {
      //   d.cities.forEach((c) => {
      //     acc[c.object_id] = d.stores[0].object_id
      //   })
      //   return acc
      // }, {})
      this.orders.forEach(o => {
        // console.log(o.store_id, o.status);
        sendMessageModal[o.id] = {
          // runner: this.$StoresNotificationSettings[citiesToStores[o.city_id]].runner[o.status] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].runner[o.status] > 0,
          // supervisor: this.$StoresNotificationSettings[citiesToStores[o.city_id]].supervisor[o.status] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].supervisor[o.status] > 0,
          runner: this.$StoresNotificationSettings[o.store_id]?.runner?.[o.status] > 0,
          supervisor: this.$StoresNotificationSettings[o.store_id]?.supervisor?.[o.status] > 0,
          runnerModal: false,
          supervisorModal: false,
        }
      })
      this.sendMessageModal = {...sendMessageModal}

      if (this.orders[0]) {
        this.localOrders = [...(this.orders[0].report_date ? _.orderBy(this.orders, 'report_date') : _.orderBy(this.orders, 'delivery_date'))]
      }
    },
    getOrderClass(id) {
      let className
      if (this.storeStatus && this.storeStatus[id]) {
        className = 'drugs_status_' + this.storeStatus[id].status
      }
      return className
    },
    orderToEdit(id) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id})
    },
    moment(date, format = 'DD.MM.YYYY') {
      return moment(date).format(format)
    },
    printCreateDate(order) {
      const date = order.delivery_date || order.report_date
      return moment(date).format('DD.MM.YYYY')
    },
    getComments(order) {
      let html = ''
      if (order.comment) {
        order.comment.forEach(c => {
          html +=
            '<div><p><small>' +
            c.created_at +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order.extra_options.comments_for_runner && order.extra_options.comments_for_runner.length) {
        html += '<div><p>Для курьера</p></div>'
        order.extra_options.comments_for_runner.forEach(c => {
          html +=
            '<div><p><small>' +
            c.created_at +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order.status < 0 && order.reject_comment) {
        html +=
          '<div><p><small>Причина отказа</small></p><p>' +
          order.reject_comment +
          '</p>'
      }
      return html
    },
  }
}
</script>

<style>
.drug_details .it-has-a-tooltip {
  display: inline-block;
  /*vertical-align: -webkit-baseline-middle;*/
  /*width: 17px;*/
  /*height: 19px;*/
  color: #5BBFDE;
  /*margin: 0 auto;*/
  cursor: pointer;
  font-size: 20px;
}

.comment_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}

.tooltip.info.custom-tooltip .tooltip-inner {
  background: rgba(91, 191, 222, 1);
  padding: 12px;
  max-width: 450px;
  text-align: left;
}

.tooltip.info.custom-tooltip .tooltip-inner div {
  margin-bottom: 10px;
}

.tooltip.info.custom-tooltip .tooltip-inner p {
  margin-bottom: 0px;
}
</style>

<style scoped>
.drug_details hr {
  margin: 2px 0;
}

.chat_icon {
  cursor: pointer;
  color: #5bbfde;
}

.chat_btn i {
  font-size: 17px;
}

.icon-snowflake {
  display: inline-block;
  /*vertical-align: -webkit-baseline-middle;*/
  height: 16px;
  width: 14px;
  background: #5BBFDE;
  /*margin: 0 auto;*/
  margin-top: 2px;
  mask: url(/assets/svg/snowflake-solid.svg);
}

p {
  margin-bottom: 2px;
}

.drugs_status_1 {
  background-color: #ffe8e8;
}

.drugs_status_2 {
  background-color: #fff6de;
}

.drugs_status_3 {
  background-color: #bce2f4;
}
</style>
